
export const WS_SERVER = 'localhost'

export const SERVER_ADDRESS = process.env.NODE_ENV === 'production'
  ? 'https://miriambixso02.github.io/akira-report/'
  : `http://${WS_SERVER}:3000/akira-report/`